var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.62464 10.3334C6.56512 10.1026 6.44486 9.89209 6.27638 9.72361C6.1079 9.55513 5.89735 9.43488 5.66664 9.37536L1.57664 8.32069C1.50686 8.30088 1.44544 8.25886 1.40171 8.20099C1.35798 8.14312 1.33432 8.07256 1.33432 8.00002C1.33432 7.92749 1.35798 7.85693 1.40171 7.79906C1.44544 7.74119 1.50686 7.69916 1.57664 7.67936L5.66664 6.62402C5.89727 6.56456 6.10776 6.44441 6.27624 6.27605C6.44471 6.10769 6.56501 5.89728 6.62464 5.66669L7.6793 1.57669C7.69891 1.50664 7.74089 1.44492 7.79885 1.40095C7.85681 1.35699 7.92756 1.33319 8.0003 1.33319C8.07305 1.33319 8.1438 1.35699 8.20176 1.40095C8.25971 1.44492 8.3017 1.50664 8.3213 1.57669L9.3753 5.66669C9.43482 5.8974 9.55508 6.10795 9.72356 6.27644C9.89204 6.44492 10.1026 6.56517 10.3333 6.62469L14.4233 7.67869C14.4936 7.69809 14.5557 7.74003 14.5999 7.79807C14.6441 7.85612 14.668 7.92706 14.668 8.00002C14.668 8.07298 14.6441 8.14393 14.5999 8.20197C14.5557 8.26002 14.4936 8.30196 14.4233 8.32136L10.3333 9.37536C10.1026 9.43488 9.89204 9.55513 9.72356 9.72361C9.55508 9.89209 9.43482 10.1026 9.3753 10.3334L8.32064 14.4234C8.30103 14.4934 8.25905 14.5551 8.20109 14.5991C8.14313 14.6431 8.07238 14.6669 7.99964 14.6669C7.92689 14.6669 7.85614 14.6431 7.79818 14.5991C7.74023 14.5551 7.69824 14.4934 7.67864 14.4234L6.62464 10.3334Z",
    stroke: "#00382F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 2V4.66667",
    stroke: "#00382F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.33331H12",
    stroke: "#00382F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.66666 11.3333V12.6666",
    stroke: "#00382F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 12H2",
    stroke: "#00382F",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.bfee89d3da6cd7a6c9d674b8a9a1fee4.svg";
export { ForwardRef as ReactComponent };